<template>
  <div>
    <v-overlay :value="isProcessing">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
    <VerifyCodeDialog
      :verificationType="emailVerificationType"
      :contactInfo="emailOnFile"
      :showDialog="showAuthorizeCodeModal"
      :onClose="() => showAuthorizeCodeModal = false"
      :onSuccess="displayUsername"
      :challengeId="challengeId"
      :onVerify="verifyRecoveryCode"
    />

    <v-row justify="center">
      <v-col lg="6" md="5" class="pb-0 hidden-sm-and-down">
        <v-img class="sticky-image" height="100vh" src="../../assets/register-dog.png" />
      </v-col>
      <v-col class="register" lg="6" md="7" sm="12">
        <div class="top-icons">
          <a class="back-icon" v-on:click="goBack">
            <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back
          </a>
        </div>
        <h1>Look up your username</h1>
        <v-form class="register-form">
          <v-text-field
            outlined
            placeholder="Member ID"
            type="text"
            v-model="memberId"
            :rules="[(v) => (!!v || !!email) || 'Either Member ID or Email is required']"
          />
          <v-text-field
            outlined
            placeholder="Email address"
            type="text"
            v-model="email"
            :rules="[(v) => (!!v || !!memberId) || 'Either Member ID or Email is required']"
          />
          <v-text-field
            outlined
            placeholder="First name"
            type="text"
            v-model="firstName"
            :rules="[(v) => !!v || 'First name is required']"
          />
          <v-text-field
            outlined
            placeholder="Last name"
            type="text"
            v-model="lastName"
            :rules="[(v) => !!v || 'Last name is required']"
          />
          <v-alert
            width="100%"
            v-if="!!errorMessage"
            dismissible
            type="error"
          >{{ errorMessage }}</v-alert>
        
        <v-alert
            width="100%"
            v-if="!!username && showUsername"
            type="info"
          >Username: {{ username }}     
          </v-alert>
        </v-form>
        
        <router-link v-if="showUsername" to="/login">Login</router-link>

        <p><strong>We will confirm your identity by sending a verification code to the email address you provided to ASCA.</strong> </p>
        <p>If you can't find your record or no longer have access to the contact email, please contact the ASCA Business Office at <a href="mailto:support@asca.org">support@asca.org</a>.</p>

        <v-btn
          :dark="isValid"
          large
          color="primary"
          v-on:click="verifyUsername"
          :disabled="!((!!memberId || !!email) && !!firstName && !!lastName)"
          v-if="!showUsername"
        >Email me the code</v-btn>

        <div class="footer-container">
          <v-img height="2rem" contain :src="logoImage" />
          <footer-text />
        </div>
      </v-col>
    </v-row> 
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import FooterText from '@/components/common/FooterText.vue';
import VerifyCodeDialog from '@/components/common/VerifyCodeDialog.vue';
import authenticationService from "@/services/authenticationService";
import { VerificationType } from "@/services/codeVerificationService";
import { UserInfo } from "@/types/User";
import personService from '@/services/portal/personService';

const logoImage = require('@/assets/logo.svg');

export default Vue.extend({
  components: { FooterText, VerifyCodeDialog },
  name: 'LinkUserToMembershipByCode',
  data() {
    return {
      logoImage,
      isProcessing: false,
      showUsername: false,  
      errorMessage: '',
      showAuthorizeCodeModal: false,
      isValid: false,
      memberId: '',
      email: '',
      firstName: '',
      lastName: '',
      emailOnFile: '',
      username: '',  
      challengeId: '',
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    emailVerificationType: function () {
      return VerificationType.Email;
    }
  },
  created: function() {  
    localStorage.removeItem("membershipLinkPersonId");
  },
  methods: {
    goBack() { this.$router.back(); },
    verifyUsername: async function() {
        this.isProcessing = true;

        const response = await authenticationService.verifyUsername(this.memberId, this.email, this.firstName, this.lastName);
        
        if(!!response.challengeId && !!response.email) {
          this.emailOnFile = response.email;
          this.challengeId = response.challengeId;
          this.errorMessage = '';
          this.isProcessing = false;
          this.showAuthorizeCodeModal = true;
          
        } else {
          this.errorMessage = !!response.messages ? response.messages.join(', ') : '';
          this.isProcessing = false;
          this.showUsername = false;
        }
    },    
    verifyRecoveryCode: personService.verifyAccountRecovery,
    displayUsername: async function(response: any) {
      this.showAuthorizeCodeModal = false;
      this.username = response.username;
      this.showUsername = true;
    },
  },
});
</script>
